import * as req from 'api/actions';
import * as c from './constants';

export const dummy = () => { };

export const getEwalletReportList = (payload = {}, callback) =>
  req.list(
    c.E_WALLET_REPORT_LIST,
    'api/v1/administrators/report_file_exports',
    payload,
    callback
  );

export const getReports = (payload, callback) =>
  req.create(
    c.GET_REPORTS,
    'api/v1/administrators/wallet/report/generate_csv',
    payload,
    callback
  );